import { Topbar } from '@shared/ui/topbar';
import { Loading } from '@shared/ui/loading';

import styles from './preview.module.css';

/**
 * Same fix, same reasoning as `pages/preview/ui/route-loading.tsx` (see its
 * doc comment) -- this page's own version, wired as `route-catalog.tsx`'s
 * `preview` route's `pendingComponent`.
 */
export function PreviewRouteLoading() {
	return (
		<div className={styles['container']}>
			<div className={styles['view']}>
				<Topbar className={styles['topbar']} />
				<Loading />
			</div>
		</div>
	);
}
